import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'

import { useStore } from 'store/useStore'
import { FeedbackForm } from 'sections/PromoSection/modules/SearchEngineModule/components/FeedbackForm/FeedbackForm'
import { Button, Modal } from 'components/uiKit'
import { PromoSiteContactRequest } from 'types/types'

import { MessagesType } from '../../types'
import { Chat } from '../Chat/Chat'
import { ChatFooter } from './ChatModalFooter/ChatModalFooter'
import { ChatHeader } from './ChatModalHeader/ChatModalHeader'

import CloseIcon from 'assets/img/searchEngine/close-icon.svg?react'
import './ChatModal.scss'

export const ChatModal = observer(() => {
  const { searchEngineUiStore: uiStore } = useStore()

  const { isOpen, toggleIsOpen, messages, setProblemReportModalOpen, problemReportModalOpen } = uiStore
  const [isPending, setIsPending] = useState(false)
  const [scrollPosition, setScrollPosition] = useState(0)

  const [shouldReset, setShouldReset] = useState(false)

  useEffect(() => {
    if (isOpen || problemReportModalOpen) {
      setScrollPosition(window.scrollY)
      document.body.style.overflow = 'hidden'
      document.body.style.position = 'fixed'
      document.body.style.top = `-${window.scrollY}px`
      document.body.style.width = '100%'
    } else {
      document.body.style.overflow = ''
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      window.scrollTo(0, scrollPosition)
    }

    return () => {
      document.body.style.overflow = ''
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      window.scrollTo(0, scrollPosition)
    }
  }, [isOpen, problemReportModalOpen])

  const addReview = async (data: PromoSiteContactRequest) => {
    setIsPending(true)
    try {
      await uiStore.sendReviewMessage(data)
    } finally {
      setIsPending(false)
    }
  }

  const handleReportModalOpen = (value: boolean) => {
    if (value) {
      setShouldReset(true)
      setProblemReportModalOpen(true)
    } else {
      setProblemReportModalOpen(false)
    }
  }

  const handleAfterOpen = () => {
    setShouldReset(false)
  }

  const dataAdapter = (messages: MessagesType[]) => {
    return messages.map((message) => {
      return {
        ...message,
      }
    })
  }

  return (
    <div>
      <Modal
        open={isOpen}
        onCancel={() => toggleIsOpen(false)}
        footer={null}
        className="searchEngineModal"
        width={'520px'}
        closeIcon={<CloseIcon />}
        centered={false}
      >
        <ChatHeader title="Помощник" caption="Онлайн" />
        <div className="modalContent">
          <div className="chatBodyWrapper">
            <Button type="default" onClick={() => handleReportModalOpen(true)} className="errorReportBtn">
              Задать вопрос менеджеру
            </Button>
            <Chat messages={dataAdapter(messages)} />
            <ChatFooter />
          </div>
        </div>
      </Modal>
      <Modal
        open={problemReportModalOpen}
        onCancel={() => handleReportModalOpen(false)}
        afterOpenChange={handleAfterOpen}
        footer={null}
        width={'520px'}
        className="searchEngineModal"
        closeIcon={<CloseIcon />}
        styles={{ body: { maxHeight: '95vh', overflowY: 'auto' } }}
        centered={false}
      >
        <ChatHeader title="Вопрос менеджеру" />
        <div className="searchEngineFeedbackFormWrapper">
          <FeedbackForm
            isFormVisible={problemReportModalOpen}
            shouldReset={shouldReset}
            setIsFormVisible={() => handleReportModalOpen(false)}
            isPending={isPending}
            isRejectVisible={uiStore.isRejectVisible}
            isResolveVisible={uiStore.isResolveVisible}
            addReview={addReview}
          />
        </div>
      </Modal>
    </div>
  )
})
